export const snapshotSchemaVersion = 1;
export const chatExportFilenamePrefix = 'copilot-chat-export';
export const chatSnapshotExtension = 'cjson';
